import { Button, Table, Divider, message } from 'antd'
import { Module } from 'api/org'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { IState } from 'reducers'
import API from 'api'
import { Lesson } from 'api/course'
import { useHistory } from 'react-router-dom'
import { COURSE_TYPE_PRIVATE } from 'api/constants'
import { BookOutlined } from '@ant-design/icons'
import menus from './menus'
import { DownloadFileModal } from 'components/DownloadFile'

interface Props {
  orgType: Module
}
const OutlineCom: React.FC<Props> = ({ orgType: module }) => {
  const [courseOutline, setCourseOutline] = useState<Lesson[]>([])
  const [semester, setSemester] = useState(1)
  const [currentGradeID, setGradeID] = useState(0)
  const [total, setTotal] = useState(0)
  const [courseLoading, setCourseLoading] = useState(false)
  const history = useHistory()
  const user = useSelector((state: IState) => state.user)
  const [finishSign, setFinishSign] = useState(false)
  const [annexesUrl, setUrl] = useState('')
  const [annexesName, setName] = useState('')
  const [annexesSuffix, setSuffix] = useState('')

  useEffect(() => {
    console.log('get module ', module)
  }, [module])

  const currentGrade = useSelector((s: IState) => s.course.currentGrade)

  const commonColumns = [
    {
      title: '序号',
      dataIndex: 'key',
      key: 'key',
      width: 60,
      render: text => {
        if (text < 9) {
          return <div style={{ width: 28 }}>{'0' + (text + 1).toString()}</div>
        } else {
          return <div style={{ width: 28 }}>{(text + 1).toString()}</div>
        }
      },
    },
    {
      title: '课程单元',
      dataIndex: 'unit',
      key: 'unit',
      width: 154,
      render: (text, record) => <div>{text}</div>,
    },
    {
      title: '课程名称',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (text, record: Lesson) => (
        <Button
          type="link"
          className="course-outline-list-button"
          style={{ textAlign: 'left' }}
          onClick={() => toCourse(record)}
          disabled={
            (user.type === 'guest' || user.type === 'student') && record.type === 0 ? true : false
          }
        >
          {text}
        </Button>
      ),
    },
    {
      title: '内容概述',
      dataIndex: 'desc',
      key: 'desc',
      width: 438,
      render: text => <div style={{ textAlign: 'justify' }}>{text}</div>,
    },
    {
      title: '学习重点',
      dataIndex: 'key_point',
      key: 'key_point',
      width: 438,
    },

    {
      title: '教具',
      dataIndex: 'tools',
      key: 'tools',
      width: 145,
      render: (text, record, index) => {
        if (index === 0) {
          return {
            children: (
              <div className="outline-tool-title-outer">
                {text.split(' ').map((t, index) => (
                  <span className="outline-tool-title" key={index}>
                    {t}
                  </span>
                ))}
              </div>
            ),
            props: {
              rowSpan: total,
            },
          }
        } else {
          return {
            props: {
              rowSpan: 0,
            },
          }
        }
      },
    },
    {
      title: '课时',
      dataIndex: 'duration',
      key: 'duration',
      width: 115,
      render: text => <span className="course-outline-list-duration">{text}</span>,
    },
  ]

  const vocationColumns = [...commonColumns]
  vocationColumns[5] = {
    title: '教具',
    dataIndex: 'tools',
    key: 'tools',
    width: 145,
    render: (text, record, index) => {
      if (index === 0) {
        return {
          children: (
            <div className="outline-tool-title-outer">
              {text.split(' ').map((t, index) => (
                <span className="outline-tool-title" key={index}>
                  {t}
                </span>
              ))}
            </div>
          ),
          props: {
            rowSpan: total,
          },
        }
      } else {
        return {
          props: {
            rowSpan: 0,
          },
        }
      }
    },
  }

  const nurseryColumns = [
    {
      title: '序号',
      dataIndex: 'key',
      key: 'key',
      width: 60,
      render: text => {
        if (text < 9) {
          return <div style={{ width: 28 }}>{'0' + (text + 1).toString()}</div>
        } else {
          return <div style={{ width: 28 }}>{(text + 1).toString()}</div>
        }
      },
    },
    {
      title: '课程名称',
      dataIndex: 'name',
      key: 'name',
      width: 154,
      render: (text, record) => (
        <Button
          type="link"
          className="course-outline-list-button"
          style={{ textAlign: 'left' }}
          onClick={() => toCourse(record)}
          disabled={
            (user.type === 'guest' || user.type === 'student') && record.type === 0 ? true : false
          }
        >
          {text}
        </Button>
      ),
    },
    {
      title: '内容概述',
      dataIndex: 'desc',
      key: 'desc',
      width: 1026,
      render: text => <div style={{ textAlign: 'justify' }}>{text}</div>,
    },

    {
      title: '教具',
      dataIndex: 'tools',
      key: 'tools',
      width: 145,
      render: (text, record, index) => {
        console.log('text ', text, record)

        if (index === 0) {
          return {
            children: (
              <div className="outline-tool-title-outer">
                {text.split(' ').map((t, index) => (
                  <span className="outline-tool-title" key={index}>
                    {t}
                  </span>
                ))}
              </div>
            ),
            props: {
              rowSpan: total,
            },
          }
        } else {
          return {
            children: <span>{text}</span>,
            props: {
              rowSpan: 0,
            },
          }
        }
      },
    },
    {
      title: '课时',
      dataIndex: 'duration',
      key: 'duration',
      width: 115,
      render: text => <span className="course-outline-list-duration">{text}</span>,
    },
  ]

  //根据返回的某个字段渲染不同的列表
  const renderCourseColumns = () => {
    if (courseOutline.length !== 0) {
      if (!courseOutline[0].key_point && !courseOutline[0].unit) {
        console.log('get 1')

        return nurseryColumns
      } else {
        console.log('get 3')

        return commonColumns
      }
    }
  }

  //跳转到详情页
  const toCourse = (course: Lesson) => {
    history.push({
      pathname: '/courses/' + course.id,
      state: {
        course: course,
        total: total,
        grade_id: currentGradeID,
      },
    })
  }

  useEffect(() => {
    setGradeID(module.grades[0].id)
    UpdateCourseList(module.grades[0].id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module.id])

  useEffect(() => {
    if (currentGradeID !== 0) {
      UpdateCourseList(currentGradeID)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semester])

  const chooseGrade = (grade_id: number) => {
    setGradeID(grade_id)
    UpdateCourseList(grade_id)
  }

  const UpdateCourseList = (grade_id: number) => {
    setCourseLoading(true)
    let type = COURSE_TYPE_PRIVATE
    //将小学低年级模块的课程链接到小学模块的一二年级
    switch (grade_id) {
      case 18:
        grade_id = 1
        break
      case 19:
        grade_id = 2
        break
      default:
        break
    }
    //前置课程
    if (semester === 0) {
      switch (grade_id) {
        case 12:
          grade_id = 8
          break
        default:
          break
      }
    }
    // TODO 获取 lesson_group_ids

    let grade = module.grades.find(g => g.id === grade_id)
    let t = grade!.lesson_groups![semester][0]

    API.listCourse([t], type).then(res => {
      console.log('get course data', grade_id, res.data)

      setCourseLoading(false)
      let courses = res.data.items[0]
      if (courses !== null) {
        let newCourseOutline = [...courses]
        newCourseOutline.forEach((course, index) => {
          course.key = index
        })
        setCourseOutline(newCourseOutline)
        setTotal(newCourseOutline.length)
      } else {
        setCourseOutline([])
      }
    })
  }

  //按学期下载课件，教案压缩包
  const downloadAnnexes = (grade_id: number, semester: number) => {
    if (user.type === 'guest') {
      message.warning({
        content: '当前用户没有权限下载',
        duration: 2,
      })
    } else {
      for (let j = 0; j < menus.length; j++) {
        if (menus[j].grade_id === grade_id) {
          menus[j].semesters.forEach((semesterGroup, index) => {
            if (semesterGroup.semester === semester) {
              setUrl(semesterGroup.url)
              setSuffix(semesterGroup.suffix)
              setName(semesterGroup.name)
              setFinishSign(true)
            }
          })
          break
        }
      }
    }
  }

  return (
    <>
      {/* 年级导航栏 */}
      <div className="course-outline-group-content-outer">
        {module.grades.map(grade => (
          <div
            key={grade.id}
            className={`course-outline-group-content ${grade.id === currentGradeID ? 'course-outline-group-content-active' : ''}`}
            onClick={() => chooseGrade(grade.id)}
          >
            {grade.name}
          </div>
        ))}
      </div>
      {/* 学期，下载导航栏 */}
      <div className="course-group-header" style={{ marginTop: 8 }}>
        <div className={`semester-group`}>
          <div className={`front-course-group ${currentGrade?.lesson_groups?.[0] ? '' : 'hide'}`}>
            <div
              className={`semester-common ${semester === 0 ? 'semester-active' : ''}`}
              onClick={() => setSemester(0)}
            >
              <BookOutlined className="front-course-icon" />
              前置课程
            </div>
            <Divider
              type="vertical"
              style={{ backgroundColor: '#BFBFBF', width: 2, top: 5 }}
              className="semester-divider"
            />
          </div>
          <div
            className={`semester-common ${semester === 1 ? 'semester-active' : ''} ${currentGrade?.lesson_groups?.[1] ? '' : 'hide'}`}
            onClick={() => setSemester(1)}
          >
            上学期
          </div>
          <Divider
            type="vertical"
            style={{ backgroundColor: '#BFBFBF', width: 2, top: 5 }}
            className="semester-divider"
          />
          <div
            className={`semester-common ${semester === 2 ? 'semester-active' : ''} ${currentGrade?.lesson_groups?.[2] ? '' : 'hide'}`}
            onClick={() => setSemester(2)}
          >
            下学期
          </div>
        </div>
        <div
          className="course-outline-group-content download-annexes"
          onClick={() => downloadAnnexes(currentGradeID, semester)}
        >
          一键下载
        </div>
      </div>
      <Table
        columns={renderCourseColumns()}
        dataSource={courseOutline}
        pagination={false}
        loading={courseLoading}
        className="course-outline-list"
      />
      <DownloadFileModal
        name={annexesName}
        suffix={annexesSuffix}
        url={annexesUrl}
        downloading={finishSign}
        setDownloading={setFinishSign}
      />
    </>
  )
}

export default OutlineCom
